import { callApiWithAuthorization } from "../CallApi";

export async function handleEntityDiscoveryPrompt({ threadId, organizationId, prompt, projectDiscoveryThreadId, previousResponseId, sessionId }) {
    const url = "/api/v0/ai/handle-entity-discovery-prompt";
    const options = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ threadId, organizationId, prompt, projectDiscoveryThreadId, previousResponseId, sessionId }),
    };
    const response = await callApiWithAuthorization(url, options);
    return response.json();
}

export async function handleAttributeDiscoveryPrompt({ threadId, organizationId, prompt, projectDiscoveryThreadId, previousResponseId, sessionId }) {
    const url = "/api/v0/ai/handle-attribute-discovery-prompt";
    const options = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ threadId, organizationId, prompt, projectDiscoveryThreadId, previousResponseId, sessionId }),
    };
    const response = await callApiWithAuthorization(url, options);
    return response.json();
}

export async function handleEntityRelationDiscoveryPrompt({ threadId, organizationId, prompt, projectDiscoveryThreadId, previousResponseId, sessionId }) {
    const url = "/api/v0/ai/handle-entity-relation-discovery-prompt";
    const options = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ threadId, organizationId, prompt, projectDiscoveryThreadId, previousResponseId, sessionId }),
    };
    const response = await callApiWithAuthorization(url, options);
    return response.json();
}

export async function handleSchemaDiscoveryPrompt({ threadId, organizationId, prompt, projectDiscoveryThreadId, fileId, previousResponseId, sessionId }) {
    const url = "/api/v0/ai/handle-schema-discovery-prompt";
    const options = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ threadId, organizationId, prompt, projectDiscoveryThreadId, fileId, previousResponseId, sessionId }),
    };
    const response = await callApiWithAuthorization(url, options);
    return response.json();
}

export async function handleRoleDiscoveryPrompt({ threadId, organizationId, prompt, projectDiscoveryThreadId, previousResponseId, sessionId }) {
    const url = "/api/v0/ai/handle-role-discovery-prompt";
    const options = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ threadId, organizationId, prompt, projectDiscoveryThreadId, previousResponseId, sessionId }),
    };
    const response = await callApiWithAuthorization(url, options);
    return response.json();
}

export async function handlePortalsDiscoveryPrompt({ threadId, organizationId, prompt, projectDiscoveryThreadId, previousResponseId, sessionId }) {
    const url = "/api/v0/ai/handle-portal-discovery-prompt";
    const options = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ threadId, organizationId, prompt, projectDiscoveryThreadId, previousResponseId, sessionId }),
    };
    const response = await callApiWithAuthorization(url, options);
    return response.json();
}

export async function handleCalculatedFieldPrompt({ threadId, organizationId, prompt, projectDiscoveryThreadId, previousResponseId, sessionId }) {
    const url = "/api/v0/ai/handle-calculated-field-prompt";
    const options = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ threadId, organizationId, prompt, projectDiscoveryThreadId, previousResponseId, sessionId }),
    };
    const response = await callApiWithAuthorization(url, options);
    return response.json();
}

export async function handlePOAssistantPrompt({ threadId, organizationId, prompt, projectDiscoveryThreadId, fileId, previousResponseId, sessionId }) {
    const url = "/api/v0/ai/handle-po-assistant-prompt";
    const options = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ threadId, organizationId, prompt, projectDiscoveryThreadId, fileId, previousResponseId, sessionId }),
    };
    const response = await callApiWithAuthorization(url, options);
    return response.json();
}

export async function handlePageDiscoveryPrompt({ threadId, organizationId, prompt, projectDiscoveryThreadId, previousResponseId, sessionId }) {
    const url = "/api/v0/ai/handle-page-discovery-prompt";
    const options = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ threadId, organizationId, prompt, projectDiscoveryThreadId, previousResponseId, sessionId }),
    };
    const response = await callApiWithAuthorization(url, options);
    return response.json();
}